export default __webpack_public_path__ + "static/media/login-image.2068fcd6.png";